import { jsx as _jsx } from "react/jsx-runtime";

/* 
    this component return every page element
*/
import React from "react";
import { handleLast5page, handleNext5page, handlePageSelected } from '../../services';
import styles from "./PageView.module.scss";

var PageView = function PageView(_ref) {
  var selected = _ref.selected,
      index = _ref.index,
      setSelected = _ref.setSelected,
      onPageChange = _ref.onPageChange,
      pageCount = _ref.pageCount;
  //indexes of pages starts from 0 to pageCount - 1
  //if index of page is zero we set firstPage class
  //if index of page equal to pageCount - 1 ,means this is last page and we set lastPage class
  //if index of page equal to selected page we set selected class
  var pageClasses = [styles.pageNumber, index === 0 ? styles.firstPage : "", index === pageCount - 1 ? styles.lastPage : "", selected === index ? styles.selected : ""].join(" ");
  var pageLinkClasses = [styles.pageNumberLink, selected === index ? styles.selected : ""].join(" "); //if index is -1 we add a button that navigates 5 pages forward
  //if index is -2 we add a button that navigates 5 pages backward
  //if index is not -1 or -2 we add a button that navigates to the indexed page

  if (index === -1) {
    return /*#__PURE__*/_jsx("li", {
      className: pageClasses,
      onClick: function onClick() {
        return handleNext5page(selected, pageCount, setSelected, onPageChange);
      },
      children: /*#__PURE__*/_jsx("a", {
        className: pageLinkClasses,
        children: "..."
      })
    }, index);
  } else if (index === -2) {
    return /*#__PURE__*/_jsx("li", {
      className: pageClasses,
      onClick: function onClick() {
        return handleLast5page(selected, pageCount, setSelected, onPageChange);
      },
      children: /*#__PURE__*/_jsx("a", {
        className: pageLinkClasses,
        children: "..."
      })
    }, index);
  } else {
    return /*#__PURE__*/_jsx("li", {
      className: pageClasses,
      onClick: function onClick() {
        return handlePageSelected(selected, index, setSelected, onPageChange);
      },
      children: /*#__PURE__*/_jsx("a", {
        className: pageLinkClasses,
        children: index + 1
      })
    }, index);
  }
};

export default PageView;